module.exports = __webpack_public_path__ + "img/app-4.b8a6560b.png";